import styled from 'styled-components';

import { theme } from '../themes/default';

export const DotSeparator = styled.div<{ color?: string }>`
  width: 4px;
  height: 4px;
  background: ${({ color }) => color || theme.darkGrey};
  border-radius: 50%;
`;
